import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {DeviceTypeGuard} from './core/guards/browser/browser.guard';
import {ContextGuard} from "./core/guards/context/context.guard";
import {Context} from "./core/models/context";
import {CompanyResolver} from "./core/resolvers/company.resolver";
import {DeviceType} from "./shared/utils/ui.utils";

// Caution order change must be considered twice as it can lead to big impact.
const routes: Routes = [
  {
    path: 'scanner',
    loadChildren: () => import('./features/products/scanner/scanner.module').then(m => m.ScannerModule),
    canActivate: [ContextGuard, DeviceTypeGuard],
    data: {
      context: Context.SCANNER,
      allowedTypes: [DeviceType.MOBILE, DeviceType.TABLET]
    },
    resolve: {company: CompanyResolver}
  },
  {
    path: 'report',
    loadChildren: () => import('./features/products/report/report.routes'),
    canActivate: [ContextGuard],
    data: {context: Context.REPORT},
    resolve: {company: CompanyResolver}
  },
  {
    path: 'appointment',
    loadChildren: () => import('./features/products/appointment/appointment.routes'),
    canActivate: [ContextGuard],
    data: {context: Context.APPOINTMENT},
    resolve: {company: CompanyResolver}
  },
  {
    path: 'collect',
    loadChildren: () => import('./features/products/collect/collect.routes'),
    canActivate: [ContextGuard, DeviceTypeGuard],
    data: {
      context: Context.COLLECT,
      allowedTypes: [DeviceType.MOBILE, DeviceType.TABLET]
    },
    resolve: {company: CompanyResolver}
  },
  {
    path: 'diagnosis',
    loadChildren: () => import('./features/products/diagnosis/diagnosis.module').then(m => m.DiagnosisModule),
    canActivate: [ContextGuard, DeviceTypeGuard],
    data: {
      context: Context.DIAGNOSIS,
      allowedTypes: [DeviceType.MOBILE, DeviceType.TABLET]
    },
    resolve: {company: CompanyResolver}
  },
  {
    path: 'not-supported', loadChildren: () => import('./features/not-supported/not-supported.module').then(m => m.NotSupportedModule),
    canActivate: [DeviceTypeGuard],
    data: {
      allowedTypes: [DeviceType.DESKTOP]
    }
  },
  {
    path: 'cookies', loadComponent: () => import('./shared/components/cookies-consent/cookies-consent.component').then(m => m.CookiesConsentComponent)
  },
  {path: ':fleet', redirectTo: 'diagnosis/:fleet', pathMatch:'prefix'},
  {path: '**', redirectTo: 'diagnosis', pathMatch: 'full'},

];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true, enableTracing: false, canceledNavigationResolution: 'computed'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
